<template>
  <div class="e-horizon-modal-header">
    <slot />
    <close-icon @click="onClosed" />
  </div>
</template>

<script>
  import ScrollUtils from 'utils/scrollUtils'
  import CloseIcon from 'components/CloseIcon'

  const events = {
    CLOSED: 'closed'
  }

  export default {
    components: {
      CloseIcon
    },
    props: {
      isMobile: {
        type: String,
        required: true
      },
      label: {
        type: String,
        default: '',
        required: false
      }
    },
    mounted () {
      if (this.isMobile === 'mobile') {
        ScrollUtils.disableScroll()
      }
    },
    destroyed () {
      ScrollUtils.enableScroll()
    },
    methods: {
      onClosed () {
        this.$emit(events.CLOSED)
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .e-horizon-modal-header {
    z-index: 5;
    top: 0;
    left: 0;
    padding: 0;
    width: 100%;
    height: 81px;
    background-color: #ffffff;
    border-bottom: 1px solid $grey-border;

    @include bp-mf-tablet {
      background-color: unset;
      height: 72px;
      position: relative;
    }

    .close-icon {
      width: 30px;
      height: 30px;
      justify-content: center;
      display: flex;
      align-items: center;
      top: 37px;
      right: 20px;
      font-size: em(12);
      color: $blue-close;

      @include bp-mf-tablet {
        top: 28px;
        right: 17px;
      }

      @include bp-mf-desktop {
        display: none;
      }
    }

  }
</style>
